import axios from 'axios';
import { base1 } from './config.js';

const CancelToken = axios.CancelToken;

export const getLoginParam = () => {
  return axios.post(`${base1}hrss/getparam.pw`).then(res => res.data);
};


export const getUserInfo = (trustticket) => {
  // return axios.get(`${base1}hrss/user_info`).then(res => res.data);
  return axios.get(`${base1}hrss/user_info?trustticket=${trustticket}`).then(res => res.data);
};

/**
 * 获取测试用户信息
 */
// export const getUserInfo = () => {
//   return axios.get(`${base1}hrss/user_info`).then(res => res.data);
// };

/**
 * 登录用户信息校验
 */
export const getLoginInfo = (props) => {
  return axios.post(`${base1}hrss/checkIdNumInfo`, props).then(res => res.data);
};

/**
 * 企业登录校验
 */
export const getUnitInfo = (params) => {
  return axios.post(`${base1}hrss/checkCompany`, params).then(res => res.data);
};

/**
 * 获取首页数据列表
 */
export const getResultData = (params) => {
  return axios.post(`${base1}hrss/dataSet`, params).then(res => res.data);
};

export const getPolicyList = (params) => {
  return axios.post(`${base1}hrss/queryPolicyList`, params).then(res => res.data);
};

export const queryPolicyDetails = (params) => {
  return axios.post(`${base1}hrss/queryPolicyDetails?id=${params.id}`).then(res => res.data);
};

export const submitForm = (params, url = `${base1}hrss/unempInfo`) => {
  return axios.post(url, params).then(res => res.data);
};
// 就业困难人员认定
export const submitWithFormData = (params, url) => {
  const headers = {
    'Content-Type': 'multipart/form-data; boundary=----WebKitFormBoundaryn8D9asOnAnEU4Js0',
  };
  return axios.post(url, params, headers).then(res => res.data);
};

export const getDict = (key) => {
  const params = {
    serviceId: 104,
    params: {
      tablename: key,
    },
  };
  return axios.post(`${base1}hrss/dataSet`, params).then(res => res.data.data);
};

/**
 * 获取民族接口
 * @param {-1:省级，'T_DIC_Nation':选择民族} key 
 * @returns 
 */
export const getNation = (key) => {
  const params = {
    serviceId: 107,
    params: {
      tablename: key,
    },
  };
  return axios.post(`${base1}hrss/dataSet`, params).then(res => {
    return res.data.data;
  },
  );
};

// 获取户籍地址信息接口
export const getAreaData = (pid) => {
  const params = {
    serviceId: 105,
    params: {
      pid,
    },
  };
  return axios.post(`${base1}hrss/dataSet`, params).then(res => res.data.data);
};
export const getTreeDict = (name, pid) => {
  const params = {
    serviceId: 106,
    params: {
      tableName: name,
      fid: pid,
    },
  };
  return axios.post(`${base1}hrss/dataSet`, params).then(res => res.data.data);
};

export const postDict = (id, name) => {
  // id为null的情况下用113接口，不是112
  const params = { serviceId: id ? 112 : 113, params: { tableName: name, id } };
  return axios.post(`${base1}hrss/dataSet`, params).then(res => res.data.data);
};
export const postSalary = (name) => {
  const params = {
    serviceId: 113,
    params: {
      tableName: name,
    },
  };
  return axios.post(`${base1}hrss/dataSet`, params).then(res => res.data.data);
};

// export const postPersonCenter = (param) => {
//   const params = {
//     serviceId: 115,
//     params: {
//       ...param,
//     },
//   };
//   return axios.post(`${base1}hrss/dataSet`, params).then(res => res.data.data);
// };

/**
 * 获取首页数据列表
 */
export const postPersonCenter = (params) => {
  const newParms = {
    serviceId: 115,
    params: {
      ...params,
    },
  }
  return axios.post(`${base1}hrss/dataSet`, newParms).then(res => res.data);
};

export const onSubmitForm = (params) => {
  return axios.post(`${base1}hrss/dataSet`, params).then(res => res.data);
};

/**
 * 事项列表数据
 * @returns 
 */
export const getPersonalService = (type) => {
  // 处理数据，将数据分为满足和不满足两个数组
  const handleData = (data) => {
    const baseData = data.data || []
    const list = baseData.filter(item => item?.object === type)
    // TODO:过滤不显示的数据，暂时没确定是否需要
    const satisfyList = []
    const dissatisfyList = []
    list && list.forEach(item => {
      if (item.value !== 0) {
        satisfyList.push(item)
      } else {
        dissatisfyList.push(item)
      }
    })
    return {
      satisfyList,
      dissatisfyList
    }
  }
  return axios.post(`${base1}hrss/personalService`).then(res => {
    const { data } = res
    const list = handleData(data)
    return list
  });
};

export const getPersonalDetail = (id) => {
  const params = {
    id: id
  }
  return axios.post(`${base1}hrss/personalDetails`, params, {
    cancelToken: new CancelToken(function executor(_cancel) {
      cancelDetailRequest = _cancel
    })
  }).then(res => res.data.data);
};

/**
 * 获取事项列表具体ID的value值
 * @param items 事项id conditionItem条件项
 * @param determine 是否取反义
 */
export const getPersonalDetailValue = (items, determine) => {
  const params = {
    items: items,
    determine: determine
  }
  return axios.post(`${base1}hrss/personalItem`, params).then(res => res.data.data);
}


/** 获取服务机构数据列表 */
export const queryFlagshipStore = (params) => {
  return axios.post(`${base1}hrss/queryFlagshipStore`, params).then(res => res.data.data);
};



/**
 * 检验用户的openId是否曾经绑定过。如果绑定过openId直接跳转到首页
 */
export const checkBindOpenId = (parm) => {
  const type = {
    type: parm
  }
  return axios.post(`${base1}/hrss/checkBind`, type).then(res => res.data);
};

/**
 * 绑定用户openId
 */
export const bindOpenId = (parms) => {
  return axios.post(`${base1}hrss/successHandle `, parms).then(res => res.data);
};

/**
 * 退出登录
 */
export const infoLoginOut = (parms) => {
  return axios.get(`${base1}hrss/loginOut `, parms).then(res => res.data);
};

/**
 *查询行政区三级表的数据字典
 * @param {*} pid
 * @returns
 */
export const getDivision = (pid) => {
  const params = {
    serviceId: 121,
    params: {
      Pid: pid,
    },
  };
  return axios.post(`${base1}hrss/dataSet`, params).then(res => res.data.data);
};


/** 获取短信验证码 */
export const getAuthCode = (params) => {
  return axios.post(`${base1}hrss/smsmessage/sendCode`, params).then(res => res.data);
};


// 用人单位信息备案
export const onUnitSubmitForm = (params) => {
  return axios.post(`${base1}hrss/informationFililg`, params);
};

/**
 * 获取零工市场列表
 * @param {*} params
 */
export const getMarketDirectory = (params) => {
  // return axios.post('/T9/plugin/apop/hrss/getMarketDirectory.pw', params).then(res => res.data);
  return axios.post(`${base1}hrss/getMarketDirectory`, params).then(res => res.data);
};

/**
 * 社保补贴历史记录查询
 * @param {身份证号} IdNum
 */
export const getSocialSubsidyHistory = (idNum, pageNo = 1, pageSize = 10) => {
  const param = {
    idNum,
    pageNo,
    pageSize
  }
  // const newParam = transformType(param)
  return axios.post(`${base1}hrss/socialSubsidy/queryHistoryRecords`, param)
    .then(res => res.data);
};

/**
 * 就业困难认定历史记录查询
 * @param {身份证号} IdNum
 */
export const getEmploymentHardHistory = (idNum, pageNo = 1, pageSize = 10) => {
  const param = {
    idNum,
    pageNo,
    pageSize
  }
  // const newParam = transformType(param)
  return axios.post(`${base1}hrss/employmentHard/getHistoryRecords`, param)
    .then(res => res.data);
};

/**
 * 申请记录查询
 * @param {身份证号} IdNum
 */
export const getApplication = (idNum, pageNo = 1, pageSize = 10) => {
  const param = {
    idNum,
    pageNo,
    pageSize
  }
  return axios.post(`${base1}hrss/socialSubsidy/queryApplicationProgress`, param)
    .then(res => res.data);
};

/**
 * 办事服务列表
  */
export const getWorkService = () => {
  // return axios.get(`${base1}hrss/wechat/getWorkServiceMenu.pw`).then(res => res.data);
  return axios.post(`${base1}hrss/getWorkServiceMenu`).then(res => res.data)
}

/** 申请时间校验接口*/
export const getSocialSubsidyTime = (param) => {
  return axios.post(`${base1}hrss/socialSubsidy/timeVerify`, param).then(res => res.data)
}
/** 补贴对象类型查询接口*/
export const getSocialSubsidy = (param) => {
  return axios.post(`${base1}hrss/socialSubsidy/querySubsidyAimType`, param).then(res => res.data)
}
/**
 * 测算结果查询接口
 * @param {*} param 用户名称,身份证号,开始时间,结束时间,申请年份
 * @returns 
 */
export const getCalculateResult = (params) => {
  // // const { idNum, startDate, name, endDate, applyYear } = param
  // const mockParams = {
  //   'idNum':     '350702199612318610',
  //   'name':      '黄严晟',
  // }
  return axios.post(`${base1}hrss/socialSubsidy/getCalculateResult`, params).then(res => res.data)
}
/**
 * 缴费查询
 * @param {*} param 用户名称,身份证号,开始时间,结束时间
 * @returns 
 */
export const getBill = (param) => {
  // const mockParams = {
  //   'idNum':     '350702199612318610',
  //   'name':      '黄严晟',
  //   'startDate': '202201',
  //   'endDate':   '202209'
  // }
  return axios.post(`${base1}hrss/socialSubsidy/queryPaySituation`, param).then(res => res.data)
}
/**
 * 条件比对接口
 * @param {*} param 用户名称,身份证号,开始时间,结束时间,申请年份
 * @returns 
 */
export const getConfirmCondition = (param) => {
  const { idNum, startDate, name, endDate, applyYear } = param
  const params = {
    idNum: idNum,
    startDate: startDate,
    endDate: endDate,
    name: name,
    applyYear: applyYear,
  }
  return axios.post(`${base1}hrss/socialSubsidy/confirmCondition`, params).then(res => res.data)
}

/**
 *  就失业登记记录查询
 * @param {身份证号} IdNum
 */
export const getEmpQuery = (idNum) => {
  const param = {
    idNum, // 身份证号
  };
  return axios.post(`${base1}/hrss/employment/empQuery`, param);
};

// 取消目前所有的请求
export let cancelDetailRequest 
